export default validations => values => {
  const errors = {};

  // eslint-disable-next-line
  for (const field in validations) {
    const value = values[field];
    errors[field] = validations[field]
      .map(validateField => validateField(value, values))
      .find(x => x);
  }

  return errors;
};



// WEBPACK FOOTER //
// ./validators/common.js